<template>
  <div class="experience-vip-receive-result">
    <ym-popup class="experience-vip-receive-result-popup"
              v-model="visible"
              :close-on-click-overlay="closeOnClickOverlay"
              get-container="body"
    >
      <div v-if="status === 'success'"
           class="experience-vip-receive-result-success-container"
      >
        <ym-img class="success-header"
                :src="require('@/assets/img/million_read/welfare/result_popup_header.png')"
        />
        <div class="success-info">
          <div class="success-info-title">
            领取成功!
          </div>
          <ym-img class="success-info-bg"
                  :src="require('@/assets/img/million_read/welfare/result_popup_bg.png')"
          />
          <div class="success-info-learn-btn"
               @click="handleStartLearn"
          >
            开始学习
          </div>
        </div>
      </div>
      <div v-else
           class="experience-vip-receive-result-fail-container"
      >
        <div class="fail-header">领取失败！</div>
        <div class="fail-info">
          <template v-if="isReceived">
            7天免费体验资格每个账号只能领取一次，你已领取过了，不可重复领取哦。
          </template>
          <template v-else-if="!isNewMember">
            7天免费体验资格为新用户专享，你暂不符合领取条件哦。
          </template>
        </div>
        <div class="fail-btn"
             @click="handleBack"
        >
          返回
        </div>
      </div>
      <div class="experience-vip-receive-result-popup-close"
           @click.stop="handleClose(visible)"
      >
        <ym-icon name="round-close" />
      </div>
    </ym-popup>
  </div>
</template>

<script>
  import { Popup } from '@ymba/ym-ui';

  export default {
    name: 'ExperienceVipReceiveResultPopup',
    components: {
      'ym-popup': Popup,
    },
    data() {
      return {
        visible: false,
      };
    },
    props: {
      show: {
        type: Boolean,
        required: true,
      },
      closeOnClickOverlay: {
        type: Boolean,
        default: true,
      },
      status: {
        type: String,
        required: true,
      },
      isReceived: {
        type: Boolean,
      },
      isNewMember: {
        type: Boolean,
      },
    },
    watch: {
      show(val) {
        this.visible = val;
      },
      visible(val) {
        this.$emit('update:show', val);
      },
    },
    methods: {
      handleClose() {
        this.visible = false;
      },
      handleStartLearn() {
        this.$emit('start-learn');
        this.handleClose();
      },
      handleBack() {
        this.$emit('back-app');
        this.handleClose();
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .experience-vip-receive-result {
    border-radius: 16px;
    width: 570px;
    overflow-y: visible;
    &-popup {
      background: transparent;
    }
    &-success-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 594px;
      .success-header {
        width: 594px;
        height: 160px;
        background: url('~@/assets/img/million_read/welfare/result_popup_header.png') no-repeat;
        background-size: 100% 100%;
        /deep/ img {
          display: block;
        }
      }
      .success-info {
        width: 540px;
        height: 560px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background: linear-gradient(0deg, #ffcf72, #ffdda5, #fff0d3);
        border-radius: 0 0 20px 20px;
        &-title {
          margin-bottom: 52px;
          color: #b32a00;
          font-size: @font-size-extra-extra-large;
          font-weight: @font-weight-strong;
          line-height: 1;
        }
        &-bg {
          width: 266px;
          height: 254px;
          margin-bottom: @size-medium;
        }
        &-learn-btn {
          width: 320px;
          height: 88px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: @color-white;
          font-size: @font-size-large;
          font-weight: @font-weight-strong;
          line-height: 1.1;
          background: #ff4d3e;
          border-radius: 44px;
        }
      }
    }
    &-fail-container {
      width: 630px;
      height: 412px;
      background: @color-white;
      border-radius: 20px;
      .fail-header {
        width: 630px;
        height: 100px;
        margin-bottom: @size-large;
        display: flex;
        align-items: center;
        justify-content: center;
        color: @color-white;
        font-size: @font-size-extra-extra-large;
        font-weight: @font-weight-strong;
        line-height: 1.1;
        background: #fe633c;
        border-radius: 20px 20px 0 0;
      }
      .fail-info {
        box-sizing: border-box;
        margin-bottom: 56px;
        padding: 0 46px;
        color: @color-text-base;
        font-size: @font-size-base;
        font-weight: @font-weight-strong;
        line-height: 1.5;
      }
      .fail-btn {
        width: 320px;
        height: 88px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
        color: @color-white;
        font-size: @font-size-large;
        font-weight: @font-weight-strong;
        line-height: 1.2;
        background: #ff4d3e;
        border-radius: 44px;
      }
    }
    &-popup-close {
      position: absolute;
      bottom: -2 * @size-extra-medium;
      left: 0;
      right: 0;
      margin: 0 auto;
      width: @size-large;
      height: @size-large;
      font-size: @size-large;
      color: @color-placeholder;
    }
  }
</style>
